import { render, staticRenderFns } from "./CollectionFeed.vue?vue&type=template&id=ea68c862&scoped=true&"
import script from "./CollectionFeed.vue?vue&type=script&lang=js&"
export * from "./CollectionFeed.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFeed.vue?vue&type=style&index=0&id=ea68c862&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea68c862",
  null
  
)

export default component.exports